/* eslint-disable max-len */
import React, { useState } from 'react';
import DashboardHeaderWithFilters from '../../../components/DashboardHeaderWithFilters';
import Dots from '../../../components/Loading/Dots';
import useFilterMethods from '../../../customHooks/useFilterMethods';
import useToast from '../../../customHooks/useToast';
import { GET_REFERRAL_MINI_STATISTICS } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import ArrowdownIcon from '../../../svgs/ArrowdownIcon';
import ArrowupIcon from '../../../svgs/ArrowupIcon';
import DecreaseChartIcon from '../../../svgs/DecreaseChartIcon';
import IncreaseChartIcon from '../../../svgs/IncreaseChartIcon';
import { formatCash } from '../../../utils/tableHelpers';
import Styles from './RewardCards.module.scss';

const RewardsCards = () => {
  const Toast = useToast();

  const [dateType, setDateType] = useState('1 Year');

  const [getReferralMiniStatistics, referralMiniStatisticsLoading, referralMiniStatistics] = useCustomQuery({
    query: GET_REFERRAL_MINI_STATISTICS,
    onError: () => {},
    onData: () => {},
  });

  const chartType = (type:string) => {
    switch (type) {
    case 'increase':

      return {
        chart: <IncreaseChartIcon />,
        icon: <ArrowupIcon />,
        color: '#027A48',
      };
    case 'decrease':
      return {
        chart: <DecreaseChartIcon />,
        icon: <ArrowdownIcon />,
        color: '#B42318',
      };

    default:
      return {
        chart: <DecreaseChartIcon />,
        icon: <ArrowdownIcon />,
      };
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const details = [
    {
      id: 1,
      title: 'Total referrals',
      value: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalReferrals || 0,
      percentage: `${parseInt(referralMiniStatistics?.getReferralMiniStatistic
        ?.totalReferralPercentageChange) || 0}%`,
      day: dateType,
      percentageIcon: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalReferralPercentageChange > 0 ? chartType('increase')?.icon : chartType('decrease')?.icon,
      type: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalReferralPercentageChange > 0 ? chartType('increase')?.chart : chartType('decrease')?.chart,
      color: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalReferralPercentageChange > 0 ? chartType('increase')?.color : chartType('decrease')?.color,
    },
    {
      id: 2,
      title: 'Successful conversions',
      value: referralMiniStatistics?.getReferralMiniStatistic
        ?.successfulConversions
        || 0,
      percentage: `${parseInt(referralMiniStatistics?.getReferralMiniStatistic
        ?.totalSuccessfulReferralPercentageChange) || 0}%`,
      day: dateType,
      percentageIcon: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalSuccessfulReferralPercentageChange > 0 ? chartType('increase')?.icon : chartType('decrease')?.icon,
      type: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalSuccessfulReferralPercentageChange > 0 ? chartType('increase')?.icon : chartType('decrease')?.chart,
      color: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalSuccessfulReferralPercentageChange > 0 ? chartType('increase')?.icon : chartType('decrease')?.color,
    },
    {
      id: 3,
      title: 'Reward amount withdrawn',
      value: `$${formatCash(referralMiniStatistics?.getReferralMiniStatistic?.totalAmountWithdrawn || 0)}`,
      percentage: `${parseInt(referralMiniStatistics?.getReferralMiniStatistic
        ?.totalAmountWithdrawnPercentageChange) || 0}%`,
      day: dateType,
      percentageIcon: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalAmountWithdrawnPercentageChange > 0 ? chartType('increase')?.icon : chartType('decrease')?.icon,
      type: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalAmountWithdrawnPercentageChange > 0 ? chartType('increase')?.chart : chartType('decrease')?.chart,
      color: referralMiniStatistics?.getReferralMiniStatistic
        ?.totalAmountWithdrawnPercentageChange > 0 ? chartType('increase')?.color : chartType('decrease')?.color,
    },
  ];

  const getReferralFunc = async (result) => {
    getReferralMiniStatistics({
      variables: {
        from: result.from,
        to: result.to,
      },
    });
  };

  const onFilterSubmit = (result) => {
    getReferralFunc(result);
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: ['dateRange'],
    defaultUrl: '/rewards/statistics?page=1',
    cb: onFilterSubmit,
    Toast,
  });

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__header}>
        <DashboardHeaderWithFilters title="Referral statistics" filterObj={filterObj} setDateLabel={(dateLable:any) => setDateType(dateLable?.label)} />
      </div>
      <div className="row">
        {
          details?.map((list:any) => (
            <div className="col-xl-4 col-lg-6">
              <div className={`${Styles.wrapper__cardContainer}`}>
                <div className={Styles.wrapper__cardTitle}>
                  {list?.title}
                </div>

                <div className={Styles.wrapper__cardValueAndChartContainer}>

                  <div className={Styles.wrapper__cardValueAndPercentage}>
                    <div className={Styles.wrapper__cardValue}>{referralMiniStatisticsLoading ? <div className={Styles.wrapper__detailsLoader}><Dots /></div> : list?.value}</div>
                    {
                      !referralMiniStatisticsLoading && (
                      <div className={Styles.wrapper__cardDayAndPercentage}>
                        <span className={Styles.wrapper__cardPercentageIcon}>{list?.percentageIcon}</span>
                        <span className={Styles.wrapper__cardPercentage} style={{ color: list?.color }}>{list?.percentage}</span>
                        vs
                        {' '}
                        <span className={Styles.wrapper__cardDay}>{list?.day}</span>
                      </div>
                      )
                    }

                  </div>
                  {
                    !referralMiniStatisticsLoading && (
                    <div className={Styles.wrapper__cardChart}>
                      {list?.type}
                    </div>
                    )
                  }

                </div>
              </div>
            </div>
          ))
        }

      </div>
    </div>
  );
};

export default RewardsCards;
